import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 117 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#D8FFFF" d="M40.5 22a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M18.55 64.439a1.5 1.5 0 0 1 .001 2.121l-9.99 10a1.5 1.5 0 1 1-2.122-2.12l9.99-10a1.5 1.5 0 0 1 2.121-.001"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M6.44 64.439a1.5 1.5 0 0 1 2.121 0l9.99 10a1.5 1.5 0 1 1-2.122 2.121l-9.99-10a1.5 1.5 0 0 1 0-2.121"
      clipRule="evenodd"
    />
    <path fill="#00D8D8" d="M100.5 105a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M107.57 50a1.5 1.5 0 0 1 1.5 1.5v14.13a1.5 1.5 0 0 1-3 0V51.5a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M99 58.57a1.5 1.5 0 0 1 1.5-1.5h14.14a1.5 1.5 0 0 1 0 3H100.5a1.5 1.5 0 0 1-1.5-1.5M22.77 16.65a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M81.57 43.31 59.45 25.68a2.9 2.9 0 0 0-3.63 0L33.71 43.31v39.71c0 2.4 1.95 4.35 4.35 4.35h39.17c2.4 0 4.35-1.95 4.35-4.35V43.31M81.57 41.1V25.49c0-.69-.56-1.26-1.26-1.26h-6.19c-.69 0-1.26.56-1.26 1.26v9.95"
    />
    <path
      fill="#D8FFFF"
      d="M67.16 87.37H48.32V59.94c0-1.31 1.06-2.37 2.37-2.37H64.8c1.31 0 2.37 1.06 2.37 2.37v27.43z"
    />
    <path
      fill="#0597A3"
      fillRule="evenodd"
      d="M56.833 28.58v.001L26.774 50.629a3 3 0 1 1-3.55-4.838L53.289 23.74a7.37 7.37 0 0 1 8.687-.006l.01.007 30.06 22.05a3 3 0 1 1-3.55 4.838l-30.05-22.042-.003-.003a1.37 1.37 0 0 0-1.609-.004M25.95 87.37a3 3 0 0 1 3-3h57.13a3 3 0 0 1 0 6H28.95a3 3 0 0 1-3-3"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      d="M83.772 84.59c5.783 0 10.47-4.687 10.47-10.47 0-5.782-4.687-10.47-10.47-10.47-5.782 0-10.47 4.688-10.47 10.47s4.688 10.47 10.47 10.47"
    />
    <path
      fill="#D8FFFF"
      d="M99.002 95.11c.65 0 1.04-.69.74-1.27-2.94-5.66-9.02-9.96-15.77-9.96s-13.14 4.18-15.9 10.2c-.25.55.18 1.18.79 1.18z"
    />
  </svg>
);
const SvgEnrichedIconHomeownerBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconHomeownerBrand);
export default Memo;
